import { Component,OnInit } from '@angular/core';
import { ChatService } from '../../service/chat-service';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { TextToSpeechService } from '../../service/text-to-speech/text-to-speech.service';
import { AvatarService } from '../../service/avatar.service';
import { RoleplayService } from '../../service/roleplay/roleplay.service';

@Component({
    selector: 'app-create-profile',
    templateUrl: './create-profile.component.html',
    styleUrl: './create-profile.component.scss',
    standalone: false
})
export class CreateProfileComponent implements OnInit {
  profileForm: FormGroup;
  professionalGoals: any[] = [];
  profile_id: number; 
  newItemText: string = '';
  imageUrl: string | ArrayBuffer | null = null;
  initialFormState: any;
  isEditMode: boolean = false;
  isSubmitted = false;
  isButtonDisabled = true;
  isEditEnabled: boolean = false;
  selectedProfileImage: File;
  test7:boolean;
  showVoiceOptions = true;
  selectedVoiceType: string = 'male';  // To store the selected voice type
  selectedVoice: string = 'en-US-AvaMultilingualNeural';
  avatarVoiceList : any[];
  datasource: any;
  voiceOptions = [];
  voiceList : any[]
  subscription: any;
  profiles: any [];
  profileLength: number;
  currentProfileId: number;
  selectedAvatarProfileName: any;
  selectedAvatarStyle: any;
  selectedAvatarImageId: any;
  business_unit_code: string = sessionStorage.getItem('businessUnitCode');

  constructor(
    private fb: FormBuilder,public router: Router,
    public ChatService: ChatService, private toastr: ToastrService,
    private route: ActivatedRoute, private dialog: MatDialog, private tts: TextToSpeechService,
    public AvatarService: AvatarService, private sharedService: RoleplayService,
  ) {}
  
  ngOnInit(): void {   

    this.route.paramMap.subscribe(params => {
      const id = +params.get('id');
      if (id) {
        this.profile_id = id;
        this.isEditMode = true;
        this.fetchDataForEdit(id);
        this.initializeForm();

      } else {
        this.initializeForm();
        this.addProffesionalGoalsField(); 
        this.getVoiceSample();
        this.getDoctorAvatars(id);
      }
    });
  }

  getDoctorAvatars(index) {
    this.subscription = this.sharedService.getAvatarListData().subscribe({
      next: (response) => {
        response.forEach(profile => {
          profile.avatar_url = this.sharedService.getDoctorProfileImageUrl(profile.file_name)
        });
        this.profiles= response;
        this.setProfile(index);
        this.selectedAvatarProfileName = this.profiles[0].name;
        this.selectedAvatarImageId = this.profiles[0].id;
        this.selectedAvatarStyle = this.profiles[0].style;
        this.setVoiceAsPerGender();
      },
      error: (error) => {
        console.error('Error fetching doctor list data', error);
      }
    });
  }

  getDoctorAvatarsEdit(avatar_profile_name) {
    this.subscription = this.sharedService.getAvatarListData().subscribe({
      next: (response) => {
        response.forEach(profile => {
          profile.avatar_url = this.sharedService.getDoctorProfileImageUrl(profile.file_name)
        });
        this.profiles= response;
        const index = this.profiles.findIndex(e => e.name === avatar_profile_name);
        this.setProfile(index);
        this.selectedAvatarProfileName = this.profiles[index].name;
        this.selectedAvatarImageId = this.profiles[index].id;
        this.selectedAvatarStyle = this.profiles[index].style;
        this.selectedVoiceType = this.profiles[index].gender.toLowerCase();
      },
      error: (error) => {
        console.error('Error fetching doctor list data', error);
      }
    });
  }

  setProfile(id: number) {
    this.currentProfileId = id;
  }

  selectProfile(id: number) {
    if (id >= 0 && id < this.profiles.length) {
      this.setProfile(id);
      this.selectedAvatarImageId = this.profiles[this.currentProfileId].id;
      this.setVoiceAsPerGender();
      this.setAvatarProfileNameAndStyle();
    }
  }

  nextProfile() {
    if(this.profiles.length > (this.currentProfileId+1) ) {
      ++this.currentProfileId;
      this.setProfile(this.currentProfileId);
      this.selectedAvatarImageId = this.profiles[this.currentProfileId].id;
      // this.setupCheckbox(this.currentProfileId);
      this.setVoiceAsPerGender();
      this.setAvatarProfileNameAndStyle();
    }
  }

  setVoiceAsPerGender() { 
    this.selectedVoiceType = this.profiles[this.currentProfileId].gender.toLowerCase();
    this.getVoiceSample();
  }

  setAvatarProfileNameAndStyle() {
    this.selectedAvatarProfileName = this.profiles[this.currentProfileId].name;
    this.selectedAvatarStyle = this.profiles[this.currentProfileId].style;
  }

  previousProfile() {
    if(this.profiles.length > this.currentProfileId && this.currentProfileId !== 0) {
      --this.currentProfileId;
        this.setProfile(this.currentProfileId);
        this.selectedAvatarImageId = this.profiles[this.currentProfileId].id;
        this.setVoiceAsPerGender();
        this.setAvatarProfileNameAndStyle();
    }
  }

  getVoiceSample() {
    this.AvatarService.getAvatarVoiceListByGender(this.selectedVoiceType).subscribe(res => {
      this.avatarVoiceList = res;
      this.selectedVoice = this.avatarVoiceList[0].id;  // Set the default voice as first item in the list
      this.chooseAvatarVoice(this.selectedVoiceType);
    });
  }

  updateVoiceSample(selectedVoiceType, selectedVoice) {
    this.AvatarService.getAvatarVoiceListByGender(selectedVoiceType).subscribe(res => {
      this.avatarVoiceList = res;
      // this.selectedVoice = this.avatarVoiceList[0].id;  // Set the default voice as first item in the list
      this.voiceList =  this.avatarVoiceList.filter(item => item.voice_gender.toLowerCase() === selectedVoiceType);
      this.voiceOptions = this.voiceList.map(item => ({
        label: item.display_name,
        value: item.voice_title,
        voiceId: item.id
      })          
      )
      this.selectedVoice = selectedVoice;  // Set the selected voice as the one selected in the list
    });
  }

  chooseAvatarVoice (voice) {
    this.voiceList =  this.avatarVoiceList.filter(item => item.voice_gender.toLowerCase() === voice);
    this.voiceOptions = this.voiceList.map(item => ({
      label: item.display_name,
      value: item.voice_title,
      voiceId: item.id
    })          
    )
  }

  onSelectionChange() {
    // this.chooseAvatarVoice(this.selectedVoiceType)
    this.getVoiceSample();
  }

  playSampleVoice () {
    const selectedVoiceTypeToPlay: any =  this.avatarVoiceList.find(item => item.id === +this.selectedVoice);
    if (!selectedVoiceTypeToPlay) {
      return;
    }
    this.tts.previewVoice('Hello, How are you?', selectedVoiceTypeToPlay.voice_title);
  }

  toggleVoiceOptions(val) {
    this.showVoiceOptions = !this.showVoiceOptions;  // Toggle the visibility
    this.test7 = !val;
  }

  initializeForm(): void {
    this.profileForm = this.fb.group({
      full_name: ['', Validators.required],
      age: ['', [Validators.required, Validators.min(15), Validators.max(110)]],
      occupation: ['', Validators.required],
      career_high: this.fb.array([this.fb.control('', Validators.required)]), // <-- FormArray now
      professional_goals: this.fb.array([]),
      profile_type: [''],
    });
    if (!this.isEditMode) {
      this.isButtonDisabled = false;
    }
    this.initialFormState = this.profileForm.value;
  }

  get career_high(): FormArray {
    return this.profileForm.get('career_high') as FormArray;
  }

  addCareerHighField(value: string = ''): void {
    this.career_high.push(this.fb.control(value, Validators.required));
  }

  removeCareerHighField(index: number): void {
    if (this.career_high.length > 1) {
      this.career_high.removeAt(index);
    }
  }

  setFormData(data: any): void {
    if (data) {
      this.profileForm.patchValue({
        full_name: data.full_name ? data.full_name.trim() : '',
        age: data.age ? data.age.trim() : '',
        occupation: data.occupation ? data.occupation.trim() : '',
        profile_type: 'Manual'
      });

      // Set career_high FormArray
      const highs = data.career_high ? data.career_high.split(';').map((h: string) => h.trim()) : [''];
      this.career_high.clear();
      highs.forEach((h: string) => this.addCareerHighField(h));
      this.selectedVoiceType = data.gender;
      const nameArray = data.professional_goals.split(', ');
      nameArray.forEach((name: string) => {
        this.addProffesionalGoalsField(name.trim());
      });

      if (data.profile_url) {
        this.imageUrl = data.profile_url;
      }
    } else {
      console.error('No data provided to set in form');
    }
  }

  filterNumeric(event: Event) {
    const input = event.target as HTMLInputElement;
    // Replace any non-numeric characters
    input.value = input.value.replace(/[^0-9]/g, '');
    this.profileForm.get('age').setValue(input.value, { emitEvent: false });
  }

  addProffesionalGoalsField(goal: string = ''): void {
    this.professional_goals.push(this.fb.group({
      goal: [goal, Validators.required]
    }));
  }

  get professional_goals(): FormArray {
    return this.profileForm.get('professional_goals') as FormArray;
  }

  removeGoals(index: number): void {
    if (this.professional_goals.length > 1) {
      this.professional_goals.removeAt(index);
    } else {
      console.error('At least one proffesional goal field is required');
    }
  }

  disableForm(): void {
    this.profileForm.disable();
    this.professional_goals.controls.forEach(control => {
      control.disable();
    });
  }

  enableForm(): void {
    this.profileForm.enable();
    this.professional_goals.controls.forEach(control => control.enable());
  }

  onEditEnable() {
    this.enableForm();
    this.isButtonDisabled = false;
  }

  fetchDataForEdit(id: number): void {
    this.ChatService.fetchDataById(id).subscribe(data => {
      this.selectedVoiceType= data.gender.toLowerCase();
      this.setFormData(data);
      this.updateVoiceSample(data.gender.toLowerCase(), data.avatar_voice_id);
      this.getDoctorAvatarsEdit(data.name);
      this.disableForm();
    });
  }
  
  addGoalInput() {
    const professionalGoalsFormArray = this.profileForm.get('professionalGoals') as FormArray;
    professionalGoalsFormArray.push(this.fb.control(''));
  }

  // Method to remove input from professionalGoals form array
  removeInput(index: number, type: string) {
    const formArray = type === 'P' ? 'professionalGoals' : 'customerValues'; // Assuming 'P' stands for professional goals
    const formArrayToRemove = this.profileForm.get(formArray) as FormArray;
    formArrayToRemove.removeAt(index);
  }

  logFormErrors() {
    Object.keys(this.profileForm.controls).forEach(key => {
      const controlErrors = this.profileForm.get(key).errors;
      if (controlErrors) {
        console.error(`Error in ${key}:`, controlErrors);
      }
    });
  
    // Log errors for nested form arrays (like professional goals)
    this.professional_goals.controls.forEach((control, index) => {
      const controlErrors = control.get('goal').errors;
      if (controlErrors) {
        console.error(`Error in professional goal ${index + 1}:`, controlErrors);
      }
    });
  }

  onEdit () {
    this.isSubmitted = true;
    if (this.profileForm.valid) {
      const formData = this.getFormData();
      this.ChatService.updateItem(this.profile_id, formData).subscribe({
        next: response => {
          if (response) {
            const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
              width: '350px',
              data: { message: `You have successfully updated the Doctor Profile!`, okOnly: true }
            });
        
            dialogRef.afterClosed().subscribe(result => {
              this.router.navigate(['/app-doctor-profile'], { skipLocationChange: true});
            });
          }
        },
        error: error => {
          console.error('Error updating item:', error);
        }
      });
    } else {
      // Form is invalid, log errors to console
      this.toastr.error('Please correct the errors in the form before submitting.', 'Form Invalid');
      this.logFormErrors();
    }
  }

  getFormData() {
    const formData = new FormData();
    formData.append('gender_voice', this.selectedVoiceType);
    formData.append('avatar_voice_id', this.selectedVoice);

    // Append form fields to the FormData object
    formData.append('full_name', this.profileForm.get('full_name').value);
    formData.append('age', this.profileForm.get('age').value);
    formData.append('occupation', this.profileForm.get('occupation').value);
    const careerHighArray = this.career_high.controls.map(control => control.value.trim());
    formData.append('career_high', careerHighArray.join('; '));

    // Handle professional goals
    const goalsArray = this.professional_goals.controls.map(control => control.get('goal')?.value.trim());
    const goalsCommaSeparated = goalsArray.join(', ');
    formData.append('professional_goals', goalsCommaSeparated);
    formData.append('profile_type', 'Manual');
    formData.append('avatar_profile_name', this.selectedAvatarProfileName);
    formData.append('style', this.selectedAvatarStyle);
    formData.append('avatar_image_id', this.selectedAvatarImageId);
    formData.append('business_unit_code', this.business_unit_code);
    return formData;
  }

  onSubmit() {
    this.isSubmitted = true;
    const formData = this.getFormData();
    if (this.profileForm.valid) {
      const formData = this.getFormData();
      this.ChatService.createDoctorProfile(formData)
        .subscribe({
          next: response => {
            if (response) {
              const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
                width: '350px',
                data: { message: `You have successfully Created Doctor Profile!`, okOnly: true }
              });
          
              dialogRef.afterClosed().subscribe(result => {
                this.router.navigate(['/app-doctor-profile'], { skipLocationChange: true});
              });
            }
          },
          error: error => {
            console.error('Error creating profile:', error);
          }
     });
    } else {
      this.toastr.error('Please correct the errors in the form before submitting.', 'Form Invalid');
      console.error('Form is invalid');
    }
  }

  cancel() {
    this.profileForm.reset(this.initialFormState);
    // this.clearFormArrays(); 
  }

  clearFormArrays() {
    // Clear professional_goals FormArray
    const professionalGoalsFormArray = this.profileForm.get('professional_goals') as FormArray;
    while (professionalGoalsFormArray.length !== 0) {
      professionalGoalsFormArray.removeAt(0);
    }
  }

  deleteProfile() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '300px',
      data: {message: 'Are you sure you want to delete?'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.ChatService.deleteDrProfile(this.profile_id).subscribe(data => {
          const status = data.status;
          const message = data.message;
          if (status == "success") {
            this.toastr.success('Deleted Successfully.', '', { positionClass: 'toast-top-right' });
            this.router.navigate(['/app-doctor-profile'], { skipLocationChange: true});
          } else {
            this.toastr.info(message, '', { positionClass: 'toast-top-right' });
          }
        });
      }
    });
  }

  deleteItem(index: number) {
    this.professionalGoals.splice(index, 1);
  }

  getImageStyles() {
    if (this.imageUrl) {
      return {
        'width': '100%',
        'max-height': '100%',
        'object-fit': 'cover'  // Ensures the image covers the container without stretching
      };
    }
    return {};  // Return empty object if no image URL is set
  }
  
  updateSelected(optionIndex: number, optionId: string, event: Event, type: string) {
    switch (type) {
      case 'P':
        this.updateSelectedSection(optionIndex, optionId, event, this.professionalGoals, 'professionalGoals');
        break;
    }
  }
  
  updateSelectedSection(optionIndex: number, optionId: string, event: Event, sectionArray: any, formControlName: string) {
    const isChecked = (event.target as HTMLInputElement).checked;
    sectionArray[optionIndex].checked = isChecked;
  }

  addItem() {
    if (this.newItemText.trim() !== '') {
      const newItem = {
        id: this.professionalGoals.length + 1,
        label: this.newItemText,
        checked: false
      };
      this.professionalGoals.push(this.fb.control(newItem));
      this.newItemText = ''; // Clear input after adding
    }
  }

  onProfileImageChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files.length) {
      const file = input.files[0];
      this.readURL(file);
      if (file.size <= 1048576) { // 1MB size limit
        this.selectedProfileImage = file;
        this.profileForm.patchValue({ profileImage: file });
      } else {
        this.toastr.error('Image size is more than 1 Mb,Please upload less than 1 Mb');
      }
    }
  }

  onFileChanged(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.readURL(file);
    }
  }

  readURL(file: File) {
    const reader = new FileReader();
    reader.onload = (e) => {
      this.imageUrl = e.target?.result;
    };
    reader.readAsDataURL(file);
  }
  
  addProfessionalGoal() {
    this.professionalGoals.push(new FormControl(''));
  }

  // Function to remove professional goal at specific index
  removeProfessionalGoal(index: number) {
    this.professionalGoals.splice(index);
  }

  backbutton() {
    this.router.navigate(['/app-doctor-profile'], { skipLocationChange: true});
  }
  
}